<header class="header">
  <!-- Logo -->
  <div class="logo-section">
    <img src="../../../../../assets/a4alogo.png" alt="Apps 4 Artists Logo" />
    <span>Apps 4 Artists</span>
  </div>

  <!-- Navigation Links -->
  <nav *ngIf="user && user?.displayName" class="links-section">
    <a
      routerLink="/"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      >Home</a
    >
    <a
      routerLink="/money"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      >Earnings</a
    >
    <a
      *ngIf="
        user.creatorType === 'verified' ||
        user.creatorType === 'premium' ||
        user.creatorType === 'label'
      "
      routerLink="/locations"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      >Locations</a
    >
    <a
      routerLink="/upload/new"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      >Upload</a
    >
    <a routerLink="pricing" routerLinkActive="active-link">Upgrade</a>

    <a
      *ngIf="user && user?.a4aAdmin"
      routerLink="admin"
      routerLinkActive="active-link"
      >Admin</a
    >
  </nav>

  <!-- User Section -->
  <div *ngIf="user && user?.displayName" class="user-section">
    <span class="user-name">{{ user?.displayName }}</span>
    <img class="user-avatar" [src]="user?.avatarUrl" alt="User Avatar" />
    <a class="logout-link" (click)="logoutUser()" title="Logout">Logout</a>
  </div>
</header>
